import React from 'react';
import PropTypes from 'prop-types';

import InfoIcon from '@mui/icons-material/Info';
import { TableCell, TableRow, Tooltip } from '@mui/material';

import { POLARIS_ROYAL_BLUE } from '../../../../../themes/theme';
import { hasRole } from '../../../../../utils/userRoles';
import CheckBox from '../../../../formElements/CheckBox';

import classes from '../../../../../commonStyles/tables.module.css';
import poolClasses from '../../submissionStyles/pools.module.css';

const SelectPoolsRow = ({ row, roles, acceptedRoles, onRowChange }) => {
    // EVENT HANDLERS
    const onCheck = (e) => {
        const updatedRow = {
            ...row,
            update: e.target.checked
        };
        onRowChange(updatedRow);
    };

    // RENDER
    return (
        <>
            <TableRow key={row.id} hover className={classes.basicRowStripes}>
                <TableCell>{row.code}</TableCell>
                <TableCell>{row.ownerName}</TableCell>
                <TableCell align="center">
                    <Tooltip title={row.requirements}>
                        <InfoIcon sx={{ color: POLARIS_ROYAL_BLUE }} width={20} height={20} />
                    </Tooltip>
                </TableCell>
                <TableCell disabled={!hasRole(acceptedRoles, roles)}>
                    <div className={poolClasses.check}>
                        <CheckBox
                            id={row.id}
                            disabled={!hasRole(acceptedRoles, roles)}
                            checked={row.update}
                            onChange={onCheck}
                        />
                    </div>
                </TableCell>
            </TableRow>
        </>
    );
};

export default SelectPoolsRow;

SelectPoolsRow.propTypes = {
    row: PropTypes.object,
    roles: PropTypes.arrayOf(PropTypes.string),
    acceptedRoles: PropTypes.arrayOf(PropTypes.string),
    onRowChange: PropTypes.func
};
